import { render, staticRenderFns } from "./Maintainers.vue?vue&type=template&id=a3590566"
import script from "./Maintainers.vue?vue&type=script&lang=js"
export * from "./Maintainers.vue?vue&type=script&lang=js"
import style0 from "./Maintainers.vue?vue&type=style&index=0&id=a3590566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports